import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/site-diary`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });
const withToken = query => new URLSearchParams({ ...query, token: token() || "" }).toString();

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const saveSettings = body => axios.put(`${base}/settings`, body, headers());
export const listEntries = body => axios.post(`${base}/list`, body, headers());
export const getMissing = () => axios.get(`${base}/missing`, headers());
export const getDay = (project, date) =>
  axios.get(`${base}/day?${new URLSearchParams({ project, date })}`, headers());
export const openDay = (project, date) => axios.post(base, { project, date }, headers());
export const updateEntry = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteEntry = id => axios.delete(`${base}/${id}`, headers());
export const refreshWeather = (id, force) =>
  axios.post(`${base}/${id}/weather`, { force }, headers());
export const proposeStaff = id => axios.post(`${base}/${id}/attendance`, {}, headers());
export const sign = (id, body) => axios.post(`${base}/${id}/sign`, body, headers());
export const correct = (id, body) => axios.post(`${base}/${id}/corrections`, body, headers());

export const listSiteDocPhotos = id => axios.get(`${base}/${id}/site-doc-photos`, headers());
export const linkPhoto = (id, body) => axios.post(`${base}/${id}/photo-links`, body, headers());
export const unlinkPhoto = (id, linkId) =>
  axios.delete(`${base}/${id}/photo-links/${linkId}`, headers());
export const uploadPhoto = (id, blob, { width, height, caption }) => {
  const body = new FormData();
  body.append("photo", blob, blob.type === "image/png" ? "photo.png" : "photo.jpg");
  body.append("width", String(width || 0));
  body.append("height", String(height || 0));
  if (caption) body.append("caption", caption);
  return axios.post(`${base}/${id}/photos`, body, headers());
};
// An <img> cannot send a header: the token goes in the query.
export const photoUrl = (id, siteDoc, photo) =>
  `${base}/${id}/photos/${siteDoc}/${photo}?${withToken({})}`;

export const createNotice = (id, obstructionId, body) =>
  axios.post(`${base}/${id}/obstructions/${obstructionId}/notice`, body, headers());
export const emailNotice = (id, obstructionId, body) =>
  axios.post(`${base}/${id}/obstructions/${obstructionId}/notice/email`, body, headers());

// A blob error body (responseType "blob") turned back into JSON, so error alerts show the
// server's message.
const readBlobError = async error => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await data.text());
    } catch {
      // not JSON: keep it
    }
  }
  throw error;
};

const fileNameFrom = (res, fallback) => {
  const header = res.headers?.["content-disposition"] || "";
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
  return encoded ? decodeURIComponent(encoded[1]) : fallback;
};

const pdf = (url, fallback) =>
  axios
    .get(url, { ...headers(), responseType: "blob" })
    .then(res => ({ blob: res.data, fileName: fileNameFrom(res, fallback) }))
    .catch(readBlobError);

export const noticePdf = (id, obstructionId) =>
  pdf(`${base}/${id}/obstructions/${obstructionId}/notice/pdf`, "Anzeige.pdf");

/** PDF of a project's diary for a period: { project, from, to, lng, photos }. */
export const reportPdf = params =>
  pdf(`${base}/report/pdf?${new URLSearchParams(params)}`, "Bautagebuch.pdf");
export const emailReport = body => axios.post(`${base}/report/email`, body, headers());

export const transcribeAudio = (blob, language) => {
  const body = new FormData();
  body.append("audio", blob, "dictation.wav");
  body.append("language", language);
  return axios.post(`${base}/voice/transcribe`, body, headers());
};
